export enum RowTableDistributionEnum {
  NONE = 0,
  UPPER_CASE = 1,
  NUMBERS = 2,
  ROMAN = 3,
}

export const ROW_TABLE_LABEL_OPTIONS = [
  { key: RowTableDistributionEnum.NONE, name: "Seleccione etiquetado de fila" },
  { key: RowTableDistributionEnum.UPPER_CASE, name: "A, B, C, ..." },
  { key: RowTableDistributionEnum.NUMBERS, name: "1, 2, 3, ..." },
  { key: RowTableDistributionEnum.ROMAN, name: "I, II, III, ..." },
];